import { createContext, useContext } from 'react';

export type LocaleKey = 'zh-CN' | 'zh-HK' | 'en-US';

/** 与 umi useIntl() 保持一致的最小实现（只需要简单的 {var} 插值） */
export interface IntlShape {
  locale: LocaleKey;
  messages: Record<string, string>;
  formatMessage: (
    descriptor: { id: string; defaultMessage?: string },
    values?: Record<string, any>,
  ) => string;
}

export interface I18nContextValue {
  intl: IntlShape;
  setLocale: (locale: LocaleKey) => void;
}

export const I18nContext = createContext<I18nContextValue | null>(null);

function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n 必须在 I18nProvider 内使用');
  return ctx;
}

/** 用法与 umi 的 useIntl 一致 */
export const useIntl = () => useI18n().intl;

/** 语言切换 */
export const useSetLocale = () => useI18n().setLocale;
